import {
  Group as MantineGroup,
  type GroupProps as MantineGroupProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type GroupProps = CoreComponentProps<MantineGroupProps, 'div'>;

export function Group({ testId, view = "all", ...rest }: GroupProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineGroup data-testid={testId} {...rest} />;
}
